import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

initComponent('.js-whats-included', section => {
  const slider = section.querySelector('.js-whats-included-swiper')
  const prevEl = section.querySelector('.js-slider-prev')
  const nextEl = section.querySelector('.js-slider-next')
  const slidesCount = section.querySelectorAll('.js-slide').length

  if (!slider || slidesCount === 0) return

  const swiper = new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 16,
    slidesPerGroup: 1,
    freeMode: false,
    navigation: {
      prevEl,
      nextEl
    },
    breakpoints: {
      1024: {
        slidesPerView: slidesCount >= 4 ? 4 : 3
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})
